import { z } from 'zod';
export const videolessMeetingKeysProperty = 'videolessMeetingJsonKeys';
export const VideolessMeetingRecordSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    [videolessMeetingKeysProperty]: z.set(z.string()).optional(),
});
